function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18 16.75a.75.75 0 01-.6-1.2 5.926 5.926 0 00.72-5.84.75.75 0 01.4-.98c.38-.16.82.02.98.4 1.02 2.42.67 5.23-.9 7.33-.15.19-.37.29-.6.29z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.83 19.25a.75.75 0 01-.6-1.2c2.14-2.85 2.61-6.67 1.23-9.96a.75.75 0 01.4-.98c.38-.16.82.02.98.4 1.59 3.78 1.05 8.16-1.41 11.44-.14.2-.37.3-.6.3z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M14.04 12.96c.63-.63 1.71-.18 1.71.71v2.93c0 1.72-.62 3.01-1.73 3.63a3 3 0 01-1.47.37c-.8 0-1.66-.27-2.54-.82l-.64-.4c-.54-.34-.63-1.1-.18-1.55l4.85-4.87zm-.02-9.18c-1.12-.62-2.55-.46-4.01.45L7.09 6.06c-.2.12-.43.19-.66.19H5c-2.42 0-3.75 1.33-3.75 3.75v4c0 2.42 1.33 3.75 3.75 3.75h1.25l9.5-9.5v-.84c0-1.72-.62-3.01-1.73-3.63z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.77 2.23c-.3-.3-.79-.3-1.09 0L2.23 20.69c-.3.3-.3.79 0 1.09a.758.758 0 001.08-.01L21.77 3.31c.31-.3.31-.78 0-1.08z"
})));